// @ts-strict-ignore
import TooltipPlatinum from '../tooltip'
import { Icon } from '../../../atoms'
import React from 'react'
import { connect } from 'react-redux'
import { brand } from '../../../redux/app-selectors'

interface IHeaderModuleProps {
  brand: 'money' | 'uswitch'
  jsonBody: {
    title: string
    subTitle: string
    tooltip: {
      title: string
      content: string
    }
    showTooltip: boolean
    intro: string
    hideIntroOnMobile: boolean
  }
  name: string
  variant: string
  rawName: string
  sys: { id: string }
}

const HeaderModule: React.FC<IHeaderModuleProps> = ({
  brand,
  jsonBody,
  name,
  sys,
  variant,
  rawName,
}: IHeaderModuleProps) => {
  const { tooltip, title, subTitle, showTooltip, intro, hideIntroOnMobile } = jsonBody

  try {
    return (
      <div className='HeaderModule' id={name}>
        <h1 className='HeaderModule__subHeader'>{subTitle}</h1>
        <div className='HeaderModule__mainHeader'>
          <h2 className='HeaderModule__title'>{title}</h2>
          {showTooltip ? (
            <div className='HeaderModule__tooltip'>
              <span
                id='tooltip-icon-id'
                className='HeaderModule__tooltip-icon'
                /* eslint-disable camelcase */
                data-click-tracking={JSON.stringify({
                  component_category: 'platinum-component',
                  component_id: sys?.id,
                  component_name: 'HeaderModule',
                  contentful_name: rawName,
                  contentful_variant: variant,
                  additionalProps: { text: `${title}: tooltip clicked` },
                })}
              >
                <Icon
                  glyph={'information-circle'}
                  size={24}
                  color={brand === 'money' ? '#924A8B' : '#141414'}
                />
              </span>
              <TooltipPlatinum
                triggerElementId={'tooltip-icon-id'}
                content={tooltip.content}
                title={tooltip.title}
              />
            </div>
          ) : null}
        </div>
        {intro && (
          <div className={`HeaderModule__Intro${hideIntroOnMobile ? '--hideOnMobile' : ''}`}>
            {intro}
          </div>
        )}
      </div>
    )
  } catch (error) {
    return <></>
  }
}

export default connect((state: FsCore.State, props: any) => {
  return {
    brand: brand(state),
    ...props,
  }
})(HeaderModule)
